/**
 * Navigation configuration.
 * All nav items are declared here — never hardcoded in layout components.
 */
export const navItems = [
  { label: 'Home',     to: '/'        },
  { label: 'About',    to: '/about'   },
  { label: 'Services', to: '/services'},
  { label: 'Products', to: '/products'},
  { label: 'Contact',  to: '/contact' },
] as const

export type NavItem = (typeof navItems)[number]
